module.exports = __webpack_public_path__ + "924ef008686a296a497faf5f6f2b989f.svg";